module.exports = __webpack_public_path__ + "media/images/flags/32/China-ad580b6d416dfeeb9e92c68b0f75392b.png";